// extracted by mini-css-extract-plugin
export var animStar = "Stars-module--animStar--3RTyv";
export var stars = "Stars-module--stars--VggZR";
export var stars2 = "Stars-module--stars2--1bPjY";
export var stars3 = "Stars-module--stars3--yJBnf";